/**
 * @generated SignedSource<<edc9448037e8c36f1240d37d88175ce8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AttendEventButton_event$data = {
  readonly endAt: string;
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly myAttendance: {
    readonly status: EventAttendeeStatus;
    readonly userId: string;
  } | null | undefined;
  readonly owner: {
    readonly __typename: "Guild";
    readonly myMembership: {
      readonly id: string;
    } | null | undefined;
  } | {
    readonly __typename: "User";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly prettyUrl: string;
  readonly rowId: string;
  readonly " $fragmentType": "AttendEventButton_event";
};
export type AttendEventButton_event$key = {
  readonly " $data"?: AttendEventButton_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttendEventButton_event">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttendEventButton_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "User",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "98966fc80cc8e310a9d176162d50b1a9";

export default node;
